import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../../../environments/environment';
import { RequestHelper } from '../../../../../shared/helper/request.helper';
import { NavigationConstant } from '../../../../../shared/constant/navigation.constant';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { LinkajaStorage } from '@shared/storage/linkaja.storage';

@Component({
  selector: 'app-login-linkaja',
  templateUrl: './linkaja-login.component.html',
  styleUrls: ['./linkaja-login.component.css']
})
export class LoginLinkajaComponent implements OnInit {
  form: FormGroup;
  inquiryResponse: any;
  isLoading: boolean;
  isSubmitted: boolean;
  hostname: any = environment.hostName;

  constructor(
    private apiService: RequestHelper,
    private router: Router,
    private linkajaStorage: LinkajaStorage
  ) {
    this.isLoading = false;
    this.isSubmitted = false;
  }

  ngOnInit() {
    if(this.linkajaStorage.data == null){
      this.router.navigate([NavigationConstant.LINKAJA_IDENTIFY]);
    }
    this.form = new FormBuilder().group({
      phoneNumber: [null, Validators.required],
      linkajaPin: [null, Validators.required]
    });
  }

  submitInquiry() {
    this.isSubmitted = true;
    if(!this.form.valid){
      return;
    }
    this.linkajaStorage.data.dataLogin=this.form.getRawValue();
    return this.router.navigate([NavigationConstant.LINKAJA_PAYMENT]);
  }

  home() {
    this.apiService.home();
  }

}